/**
 * @category  ScandiPWA
 * @author    Nikoloz Gabunia <info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2020 Scandiweb, Inc (https://scandiweb.com)
 */

export const CHECKOUT_COM_PATH = '/checkout_com';

export const CHECKOUT_COM_NAME = 'Checkout';

export class NavigationTabsContainer {
    /**
     * Data map
     * @param originalMember
     * @returns {*}
     */
    aroundDataMap = (originalMember) => ({
        [CHECKOUT_COM_PATH]: { name: CHECKOUT_COM_NAME },
        ...originalMember
    });
}

export const {
    aroundDataMap
} = new NavigationTabsContainer();

export default {
    'Component/NavigationTabs/Container': {
        'member-property': {
            routeMap: [
                {
                    position: 100,
                    implementation: aroundDataMap
                }
            ]
        }
    }
};
